import { WarningFlag } from '../index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export default WarningFlag;
